import { render } from "./dyhd.vue?vue&type=template&id=61e69c0c&scoped=true&ts=true"
import script from "./dyhd.vue?vue&type=script&lang=ts"
export * from "./dyhd.vue?vue&type=script&lang=ts"

import "./dyhd.vue?vue&type=style&index=0&id=61e69c0c&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e69c0c"]])

export default __exports__